import Dashboard from "views/Pages/isostaffdashboard/Dashboard";
import Rewards from "views/Pages/isoadminreward/Rewards";
import NewProfile from "views/Pages/isostaffnewprofile/NewProfile";
import MerchantProfile from "views/Pages/isoadminmerchantprofile/MerchantProfile";
import TempMerchantProfile from "views/Pages/isoadmintempprofile/TempMerchantProfile";
import Profile from "views/Pages/isoadminprofile/Profile";
import IsoAdminBatchDetails from "views/Pages/isoadminreports/batchdetails/IsoAdminBatchDetails";
import SalesByMerchant from "views/Pages/isoadminreports/salesByMerchant/SalesByMerchant";
import MerchantList from "views/Pages/isoadminreports/salesByMerchant/MerchantList";

var isoStaffRoutes = [
  {
    path: '/:iso/reports/batch/:id/:id',
    name: 'Batch Details',
    component: IsoAdminBatchDetails,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/reports/sales-by-merchant/:id',
    name: 'Reports',
    component: SalesByMerchant,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/reports/sales-by-merchant',
    name: 'Reports',
    component: MerchantList,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/merchants',
    name: 'Merchants',
    component: Dashboard,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/rewards',
    name: 'Merchants',
    component: Rewards,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/add-merchant',
    name: 'Add Merchant',
    component: NewProfile,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/user-profile/:id',
    name: 'Merchant Profile',
    component: MerchantProfile,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/temp-user-profile/:id',
    name: 'Merchant Profile',
    component: TempMerchantProfile,
    layout: '/iso-staff',
  },
  {
    path: '/:iso/profile',
    name: 'Profile',
    component: Profile,
    layout: '/iso-staff',
  },
]

export default isoStaffRoutes;